import styled from 'styled-components';
var ModalBody = styled.div.withConfig({
  displayName: "Bodystyles__ModalBody",
  componentId: "sc-15sbf0p-0"
})(["background:var(--dentsu-color-white);color:var(--dentsu-color-n1000);font-size:var(--dentsu-font-size-14);line-height:var(--dentsu-leading-normal);padding:var(--dentsu-spacing-40) var(--dentsu-spacing-48) var(--dentsu-spacing-48);flex:1;margin:0;overflow:auto;position:relative;"]);
export var Styled = {
  ModalBody: ModalBody
};